export class AuthV2ForgotPasswordRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2ForgotPasswordRequest.attributeTypeMap;
    }
    constructor() {
    }
}
